/**
 * Parse JSON from a fetch Response; on non-OK, prefer API `{ error: string }` body.
 */
export async function jsonOrThrow(response) {
  const contentType = response.headers.get('content-type') ?? '';
  const isJson = contentType.includes('application/json');
  const body = isJson ? await response.json().catch(() => null) : null;

  if (!response.ok) {
    const fromApi =
      body && typeof body === 'object' && typeof body.error === 'string'
        ? body.error
        : '';
    throw new Error(
      fromApi || `Request failed (HTTP ${response.status})`,
    );
  }

  if (body === null || body === undefined) {
    throw new Error(
      isJson
        ? 'API returned an empty or invalid JSON response.'
        : `API returned non-JSON (Content-Type: ${contentType || 'unknown'}). Start the PHP server on port 8080 (see proxy in web/package.json).`,
    );
  }

  return body;
}

/** User-visible text when browse/search data loading fails. */
export function describeLoadFailure(err) {
  if (err instanceof TypeError) {
    const m = String(err.message);
    if (m === 'Failed to fetch' || m.includes('NetworkError')) {
      return 'Could not reach the API. Start the PHP server on port 8080 (see proxy in web/package.json).';
    }
  }
  if (err instanceof Error && err.message) {
    return err.message;
  }
  return 'Something went wrong while loading data.';
}
